
import styled from "styled-components";

export const InputWrapper = styled.div`
  width: 100%;
`;

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const RadiusSubtext = styled.span`
  font: normal normal normal 14px/19px Open Sans;
  color: #707070;
  margintop: 7px;
`;

export const SameOrderSubtext = styled.span`
  font: normal normal 600 12px/17px Open Sans;
  color: #658ccf;
`;

export const ModalContent = styled.div`
  background: #ffffff;
  border-radius: 8px;
  width: 814px;
  max-height: 80%;
  overflow-y: auto;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  position: relative;
  font-family: "Open Sans", sans-serif;
`;

export const ModalHeader = styled.div`
  padding: 16px;
  color: #333333;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e0e0e0;
  text-align: left;
  font: normal normal 600 16px/22px Open Sans;
  letter-spacing: 0px;
  color: #697979;
  opacity: 1;

  button {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #697979;
  }
`;

export const ModalBody = styled.div`
  padding-bottom: 30px;
  padding-left: 30px;
  padding-right: 30px;
`;

export const Row = styled.div`
  display: flex;
  gap: 16px;
  justify-content: space-between;
`;

export const InputGroup = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-top: 30px;
`;

export const Label = styled.label`
  margin-bottom: 8px;
  font: normal normal normal 16px/22px Open Sans;
  letter-spacing: 0px;
  color: #707070;
  opacity: 1;
`;

export const Input = styled.input`
  padding: 10px;
  font: normal normal normal 16px/22px Open Sans;
  letter-spacing: 0px;
  color: #707070;
  border: 1px solid #e4e4e4;
  border-radius: 4px;
  height: 40px;
  width: ${({ width }) => width || "100%"};

  &::placeholder {
    color: #707070;
    opacity: 0.5;
  }

  &:focus {
    outline: none;
  }
`;

export const Select = styled.select`
  padding: 8px;
  font: normal normal normal 16px/22px Open Sans;
  color: #707070;
  border: 1px solid #e4e4e4;
  border-radius: 4px;
  appearance: none;
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%23666666'%3E%3Cpath fill-rule='evenodd' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' clip-rule='evenodd'/%3E%3C/svg%3E")
    no-repeat right 12px center;
  background-color: #ffffff;
  background-size: 18px;

  &::-ms-expand {
    display: none;
  }

  &:focus {
    outline: none;
  }
`;

export const LayerTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
`;

export const Tag = styled.div`
  padding: 6px 6px 6px 12px;
  border: 1px solid #006f35;
  border-radius: 50px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #006f35;
  font: normal normal 600 13px/15px Open Sans;

  button {
    background: none;
    border: none;
    color: #cd1f1f;
    cursor: pointer;
    font-size: 16px;
  }
`;

export const SelectAllLayersButton = styled.button`
  background-color: transparent;
  color: #006f35;
  border: none;
  cursor: pointer;
  font: normal normal normal 16px/22px Open Sans;

  &:hover {
    text-decoration: underline;
  }
`;

export const InfoBox = styled.div`
  display: flex;
  align-items: center;
  background: #f0f8ff;
  padding: 8px;
  margin-top: 16px;
  border-radius: 4px;
  font-size: 12px;
  color: #333;
  border: 1px solid #658ccf;

  svg {
    color: #0077c8;
    margin-right: 8px;
  }
`;

export const ModalFooter = styled.div`
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: flex-end;
  padding: 32px;
  gap: 20px;

  button {
    padding: 8px 24px;
    border: none;
    border-radius: 40px;
    font: normal normal normal 18px/22px Open Sans;
    cursor: pointer;
  }

  .cancel {
    background: #fff;
    border: 1px solid #006f35;
    color: #333;
  }

  .download {
    background: #006f35;
    color: #fff;
  }
`;